import React from 'react';
import { Field } from 'redux-form';
import { Text } from '@ma-react/components';

import Select from 'components/Input/Select';
import YesNoOptions from 'components/Input/YesNoOptions';
import Label from 'components/Label';
import NonOwnerQuestions from 'components/NonOwnerQuestions';
import ProjectQuestions from 'components/ProjectQuestions';
import Tabs from 'components/Tabs/Container';
import Tab from 'components/Tabs/Tab';
import { USER_PROFILE, USER_PROFILE_REALTOR_POSITIONS } from 'constants/Global';
import { translate } from 'helpers/Translate';

/**
 * Step ProjectDefinition
 * @param {Object} values
 * @param {Function} change - Function from reduxForm to update Redux state
 */
const ProjectDefinition = ({ values, change }) => (
    <div data-step-project-definition>
        <Tabs
            navClassName="margin-bottom-quadruple margin-top-double"
            activeTabIndex={values.user_is_pro ? 1 : 0}
        >
            <Tab
                idPrefix="project-definition"
                title={translate('Je suis un particulier')}
                onClick={() => change('user_is_pro', false)}
            >
                <div className="row-container">
                    <div className="row-container__label row-container__label--yes-no">
                        <Label
                            labelFor="profile_owner"
                            text={translate('Êtes-vous propriétaire de ce bien ?')}
                        />
                    </div>
                    <div className="row-container__field row-container__field--yes-no">
                        <YesNoOptions name="profile_owner" />
                    </div>
                </div>
                <Text
                    size="xs"
                    className="no-padding-sm-top padding-top padding-sm-bottom-double padding-bottom-triple"
                >
                    {translate(
                        "En fournissant ces informations, vous pourrez être mis en relation avec nos experts immobiliers ou un professionnel de l'immobilier local afin de mieux vous accompagner dans votre projet.",
                    )}
                </Text>
                {values.profile_owner === true && <ProjectQuestions values={values} />}
                {values.profile_owner === false && <NonOwnerQuestions values={values} />}
            </Tab>
            <Tab
                idPrefix="project-definition"
                title={translate('Je suis un professionnel de l’immobilier')}
                onClick={() => change('user_is_pro', true)}
            >
                <div className="row-container row-container--padding-bottom">
                    <div className="row-container__label">
                        <Label
                            labelFor="user_profile"
                            text={translate('Votre activité professionnelle')}
                        />
                    </div>
                    <div className="row-container__field">
                        <Field component={Select} name="user_profile" options={USER_PROFILE} />
                    </div>
                </div>
                {values.user_profile === 'USER_PROFILE.REALTOR' && (
                    <div className="row-container">
                        <div className="row-container__label">
                            <Label
                                labelFor="user_profile_realtor_positions"
                                text={translate('Votre fonction')}
                            />
                        </div>
                        <div className="row-container__field">
                            <Field
                                component={Select}
                                name="user_profile_realtor_positions"
                                options={USER_PROFILE_REALTOR_POSITIONS}
                                emptyOption
                            />
                        </div>
                    </div>
                )}
            </Tab>
        </Tabs>
    </div>
);

ProjectDefinition.displayName = 'ProjectDefinition';

/**
 * ProjectDefinition Functional Component.
 */
export default ProjectDefinition;
